module.exports = __webpack_public_path__ + "img/gal_33.75126359.png";